import React, { useState } from "react";

const faqs = [
  {
    question: "What is Carmie?",
    answer:
      "Carmie is the first automotive repair app in East Africa, connecting clients to trusted mechanics, garages, and other car services.",
  },
  {
    question: "How do I find a mechanic on Carmie?",
    answer:
      "Simply sign up, enter your car issue or select a service from our list. Carmie will automatically match you with the closest garage mechanic or any other of your interest.",
  },
  {
    question: "Is Carmie available in all cities?",
    answer:
      "Carmie is expanding rapidly! Currently, we operate in select cities, but we are working on expanding our reach.",
  },
  {
    question: "Are the mechanics verified?",
    answer:
      "Yes! We thoroughly vet and verify all mechanics on our platform to ensure quality and reliability.",
  },
  {
    question: "How do I join Carmie as a service provider?",
    answer:
      "If you're a mechanic or garage owner, you can sign up on our platform and go through the verification process to start receiving clients.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-[#F5F5F5] min-h-screen py-20 flex items-center justify-center">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Title */}
        <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-800 text-center">
          Frequently Asked Questions
        </h2>
        <p className="text-lg text-gray-700 text-center mt-4">
          Find answers to common questions about Carmie.
        </p>

        {/* FAQ List */}
        <div className="mt-10 space-y-4 max-w-2xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-400">
              <button
                className="w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800"
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span className="text-2xl">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              {openIndex === index && (
                <p className="text-gray-700 pb-4 px-2">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
